import React from "react";
import { FormControlLabel, Stack, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

const PrivilegeCheckboxes = ({
  administrator,
}) => {
  return (
    <Stack width="80%">
      <FormControlLabel
        control={
          <Checkbox
            id="administrator"
            name="administrator"
            defaultChecked={administrator}
          />
        }
        label={
          <Typography variant="body1">
            Grant Administrator Privilege
          </Typography>
        }
      />
    </Stack>
  );
};

export default PrivilegeCheckboxes;